import { FunctionalComponent, h } from 'preact';
import { IconProps } from 'ui/icons/icon';

export const SpinnerIcon: FunctionalComponent<IconProps> = (props) => {
	const { size = 16, fill = 'currentColor', className } = props;

	return (
		<svg width={size} height={size} viewBox={'0 0 16.2 16.2'} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<g clipPath="url(#SpinnerIcon)">
				<path
					d="M14.879 11.683l-.217-.126a.376.376 0 01-.146-.496 6.763 6.763 0 00-.17-6.436 6.764 6.764 0 00-5.493-3.366A.374.374 0 018.5.885v-.25c0-.216.181-.386.397-.375a7.766 7.766 0 016.316 3.865 7.765 7.765 0 01.188 7.401.376.376 0 01-.522.157z"
					fill={fill}/>
			</g>
			<defs>
				<clipPath id="SpinnerIcon">
					<path fill={fill} transform="translate(.5)" d="M0 0h16v16H0z"/>
				</clipPath>
			</defs>
		</svg>
	);
};
